/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UtilizationMetricIdentityForAi extends models.UtilizationMetricIdentity {
    getFixupPrototypeFunction() { return UtilizationMetricIdentityForAi.fixupPrototype; }

    static newInstance(model: Partial<UtilizationMetricIdentityForAi>): UtilizationMetricIdentityForAi {
        let obj = Object.assign(new UtilizationMetricIdentityForAi(), model);
        UtilizationMetricIdentityForAi.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UtilizationMetricIdentityForAi>): UtilizationMetricIdentityForAi {
        if (!model) return null;
        return UtilizationMetricIdentityForAi.newInstance(<UtilizationMetricIdentityForAi> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UtilizationMetricIdentityForAi) {
        if (!obj) return;

        models.UtilizationMetricIdentityForAi.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UtilizationMetricIdentityForAi): boolean {
        if (models.UtilizationMetricIdentity.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, UtilizationMetricIdentityForAi.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.tags) {
            for (let val of this.tags) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
    }

    /**
     * friendly display name of resource_id (AI: the Anthropic workspace name); descriptive only, never a join or identity key
     */
    resource_name: string;

    /**
     * AI model / deployment name (identity extension)
     */
    model: string;

    /**
     * raw cloud metric name (AI, descriptive/provenance; not the join key)
     */
    meter_key: string;

    /**
     * unit canonically paired with the meter key
     */
    unit: string;

    /**
     * AI caller type (apim_subscription / entra_principal / foundry_agent / deployment_total ...)
     */
    caller_type: string;

    /**
     * AI caller identifier (empty for deployment_total)
     */
    caller_id: string;

    /**
     * AI caller human-readable display name
     */
    caller_resource_name: string;

    /**
     * AI telemetry source identifier
     */
    source: string;

    /**
     * AI region, projected from the stored resource_region
     */
    location: string;

    /**
     * List of tag key/value pairs
     */
    tags: Array<models.KeyValuePair>;

}
